'use strict';

var FirebaseCalendarDays = function FirebaseCalendarDays() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // { loading: boolean, numberOfListeners: number, data: {}, info: {date, uid}}
  action = arguments[1];

  switch (action.type) {
    case 'SCHEDULE_START_SYNCING_CALENDAR':
      {
        var newState = Object.assign({}, state);

        // Create calendarId entry for the first time
        var combinedId = action.calendarId + '->' + action.dateStr;
        if (newState[combinedId]) {
          // Already syncing this date, so increase number of listeners on a new
          // copy of the info
          var newInfo = Object.assign({}, newState[combinedId]);
          newInfo.numberOfListeners++;
          newState[combinedId] = newInfo;
        } else {
          // Add the new Pair of <calendarId,date>
          newState[combinedId] = {
            numberOfListeners: 1,
            dateStr: action.dateStr,
            calendarId: action.calendarId
          };
        }

        return newState;
      }

    case 'SCHEDULE_STOP_SYNCING_CALENDAR':
      {
        var _combinedId = action.calendarId + '->' + action.dateStr;
        // Weird? Trying to stop a <calendar,date> which is not currently been synced
        if (!state[_combinedId]) {

          // WTF error
          return state;
        }

        var _newState = Object.assign({}, state);
        var currInfo = _newState[_combinedId];
        if (currInfo.numberOfListeners > 1) {
          // Some listeners are still watching this pair, so decrease number
          // of listeners on a new copy of the info
          var _newInfo = Object.assign({}, currInfo);
          _newInfo.numberOfListeners--;
          _newState[_combinedId] = _newInfo;
        } else {
          // Remove this date
          delete _newState[_combinedId];
        }

        return _newState;
      }

    default:
      return state;
  }
};

module.exports = FirebaseCalendarDays;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/reducers/ScheduleCalendarDays.js
// module id = 1025
// module chunks = 0